import dayjs from 'dayjs';
import { CriticalityLevel, DEFAULT_CRITICALITY_LEVELS } from 'utils/issueCriticality';

export type IssuesUiConfig = {
  nearNearDueDays: number;
  nearDueDays: number;
  pastDueColor: string;
  nearNearDueColor: string;
  nearDueColor: string;
  normalDueColor: string;
  inactiveColor: string;
  adHocAutomaticNotificationsEnabled: boolean;
  issueAutomaticNotificationsEnabled: boolean;
  notifyChannelEmail: boolean;
  notifyChannelSms: boolean;
  notifyChannelPush: boolean;
  criticalityLevels: CriticalityLevel[];
};

export const DEFAULT_ISSUES_UI_CONFIG: IssuesUiConfig = {
  nearNearDueDays: 7,
  nearDueDays: 14,
  pastDueColor: 'error.main',
  nearNearDueColor: 'warning.main',
  nearDueColor: 'warning.main',
  normalDueColor: 'success.main',
  inactiveColor: 'text.secondary',
  adHocAutomaticNotificationsEnabled: true,
  issueAutomaticNotificationsEnabled: true,
  notifyChannelEmail: true,
  notifyChannelSms: true,
  notifyChannelPush: true,
  criticalityLevels: DEFAULT_CRITICALITY_LEVELS
};

export function getAdHocDueDateColor(
  dueDate: string | undefined,
  status: string | undefined,
  config?: Partial<IssuesUiConfig> | null
) {
  const cfg: IssuesUiConfig = { ...DEFAULT_ISSUES_UI_CONFIG, ...(config || {}) } as IssuesUiConfig;
  if (!dueDate || status === 'RESOLVED' || status === 'ARCHIVED') return cfg.inactiveColor;
  const today = dayjs().startOf('day');
  const due = dayjs(dueDate).startOf('day');
  const diff = due.diff(today, 'day');
  if (diff < 0) return cfg.pastDueColor;
  const nearNearDays = Math.max(
    0,
    Number(cfg.nearNearDueDays) || DEFAULT_ISSUES_UI_CONFIG.nearNearDueDays
  );
  const nearDays = Math.max(0, Number(cfg.nearDueDays) || DEFAULT_ISSUES_UI_CONFIG.nearDueDays);
  const safeNearNear = Math.min(nearNearDays, nearDays);
  if (diff <= safeNearNear) return cfg.nearNearDueColor;
  if (diff <= nearDays) return cfg.nearDueColor;
  return cfg.normalDueColor;
}
